// extracted by mini-css-extract-plugin
export default {"root":"OQ8Tzd","iframe":"nKphmK","hidden":"pvlz2w"};